export default __webpack_public_path__ + "static/media/Royal expansion.e489737d.jpg";